import { DOCUMENT } from '@angular/common'
import { Component, effect, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { fadeOut } from '@animations/fades'
import { Loader } from '@components/loader'
import { LoaderState } from '@states/loader'
import { UrlParametersState } from '@states/url-parameters'
import { applyLocationTheme } from '@utils/theme-utils'

@Component({
	selector: 'app-root',
	template: `
		<router-outlet />
		@if (isLoading()) {
			<loader @FadeOut />
		}
	`,
	imports: [RouterOutlet, Loader],
	animations: [fadeOut],
})
export class AppComponent {
	readonly #document = inject(DOCUMENT)
	readonly #loaderState = inject(LoaderState)
	readonly #urlParametersState = inject(UrlParametersState)

	readonly isLoading = this.#loaderState.isLoading

	constructor() {
		effect(() => this.#setClassInBody())
		effect(() => {
			const params = this.#urlParametersState.urlParameters()

			if (!params) return

			applyLocationTheme(params.uuid, this.#document)
		})
	}

	#setClassInBody(): void {
		const isLoading = this.isLoading()
		const body = this.#document.body

		if (isLoading) {
			body.classList.add('overflow-hidden')
		} else {
			body.classList.remove('overflow-hidden')
		}
	}
}
